import { render, staticRenderFns } from "./PerformanceModal.vue?vue&type=template&id=1f778f24"
import script from "./PerformanceModal.vue?vue&type=script&lang=js"
export * from "./PerformanceModal.vue?vue&type=script&lang=js"
import style0 from "./PerformanceModal.vue?vue&type=style&index=0&id=1f778f24&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports